import {createContext} from 'react'

export const UserRoleContext = createContext()